// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__635EK","label":"styles_label__1OGsW"};